var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-rule-yu-shang"},[_vm._m(0),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"imgclass"},[_c('img',{attrs:{"src":require("../assets/topdiy.png")}})])
}]

export { render, staticRenderFns }